import { AppLayout } from "layout";
import { CartData } from "modules/CartCheckOut/components";

type Props = {};

const CartContainer = (props: Props) => {
  return (
    <AppLayout>
      <CartData />
    </AppLayout>
  );
};

export default CartContainer;
